'use client';

import { styled } from '@mui/material';

export const UnstyledList = styled('ul')(() => ({
    listStyle: 'none',
    padding: 0,
    margin: 0,
}));
